import React from "react"
import Modal from "@components/modal"
import BlockHero from "@components/common/blockHero"
import ModalActuacionContent from "@components/common/modalActuacionContent"
import Image from "@images/actuacion/modal/anticipamos/anticipamos.png"
import Virtual from "@images/actuacion/modal/anticipamos/virtual.png"

import Icon3 from "@images/icons/es/cert-icon-03.png"
import Icon9 from "@images/icons/es/cert-icon-09.png"
import Icon17 from "@images/icons/es/cert-icon-17.png"
import Convocatoria from "@images/actuacion/modal/anticipamos/convocatoria.png"
import Alfonso from "@images/actuacion/modal/anticipamos/alfonso.png"
import BtnVer from "@components/common/btnVer"
import ChangeModalBtn from "@components/common/changePageBtn"

const Anticipamos = () => {
  return (
    <Modal title="La nostra actuació l’any 2020">
      <div className="mainModal-container">
        <div className="element">
          <BlockHero>
            <div className="title">Anticipem</div>
            <div className="subtitle">les necessitats de futur</div>
            <div className="description">
              La transformació digital és un dels pilars clau de l'estratègia de
              creixement de Mutua Universal com a motor per al desenvolupament
              de nous serveis i de la millora contínua de l'atenció a les
              empreses associades i als treballadors protegits.
            </div>
          </BlockHero>
        </div>
        <div className="element anticipamos">
          <ModalActuacionContent>
            <div className="row">
              <div className="image">
                <img src={Image} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="sideA">
                  <div className="title">Acceleració de l'agenda digital</div>
                  <div className="subtitle">
                    La unitat encarregada de promoure l'agenda digital d'acord
                    amb l'estratègia de Mutua Universal és l'Oficina de
                    Transformació Digital. Les accions desenvolupades el 2020
                    per donar resposta a les noves necessitats sorgides durant
                    la pandèmia demostren el caràcter transversal i
                    multidisciplinari de la seva actuació:
                  </div>
                  <div className="list">
                    <ul>
                      <li>
                        Adequació de plataformes i serveis per a la gestió de
                        prestacions extraordinàries per a autònoms.
                      </li>
                      <li>Posada en marxa del servei de Teleconsulta.</li>
                      <li>
                        Adaptació dels sistemes informàtics per incloure la
                        informació extraordinària relativa als processos
                        COVID-19.
                      </li>
                      <li>
                        Desenvolupament de solucions col·laboratives (Teams i
                        Zoom) per mantenir la comunicació remota entre els
                        treballadors de l'Entitat.
                      </li>
                      <li>
                        Continuïtat en el desenvolupament del projecte Lince
                        d'intel·ligència artificial.
                      </li>
                      <li>
                        Evolució de l’oficina digital a través de la notificació
                        electrònica i el servei de certificat digital.
                      </li>
                      <li>
                        Digitalització i millora dels processos de compres
                        sanitàries.
                      </li>
                    </ul>
                  </div>
                  <div className="number">
                    <span>91.000</span>
                    <span>
                      presol·licituds de prestacions per a autònoms gestionades
                      mitjançant dos processos d'automatització RPA
                    </span>
                  </div>
                </div>
                <div className="sideB">
                  <div className="image">
                    <img src={Virtual} alt=""></img>
                  </div>
                  <div className="descritpion">
                    <strong>
                      Aplicació de la realitat virtual a la gestió de l'estrès.
                    </strong>{" "}
                    L’any s’ha fet una prova de concepte que ha permès dissenyar
                    i desenvolupar dues experiències basades en entorns
                    virtuals.
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="title">ODS D’IMPACTE DIRECTE</div>
              <div className="icons">
                <img src={Icon3} alt=""></img>
                <img src={Icon9} alt=""></img>
                <img src={Icon17} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="side">
                  <div className="title">
                    Aposta per la intel·ligència artificial per a la millora
                    contínua del servei
                  </div>
                  <div className="description">
                    Un dels objectius del Pla Estratègic 2018-2020 ja implantat
                    és la introducció de la intel·ligència artificial i
                    l'anàlisi predictiva per optimitzar la gestió de
                    contingències. Aquesta aposta permet obtenir coneixements
                    propis per aplicar aquestes tecnologies a la millora
                    d'altres serveis i posicionar Mutua Universal com una
                    entitat orientada a les dades.
                  </div>
                </div>
                <div className="side">
                  <div className="title">
                    <div className="image">
                      <img src={Alfonso} alt=""></img>
                    </div>
                    <span>
                      "Tecnologies com la intel·ligència artificial o el machine
                      learning ajuden els professionals mèdics en la presa de
                      decisions perquè puguin centrar-se en la interacció
                      personal amb el pacient"
                    </span>
                  </div>
                  <div className="description">
                    <span>Alfonso Valencia</span>, director del Departament de
                    Ciències de la Vida del Centre de Supercomputació de
                    Barcelona i director de l'Institut Nacional de
                    Bioinformàtica.
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="content">
                  <div className="image">
                    <img src={Convocatoria} alt=""></img>
                  </div>
                  <div className="top">
                    <div className="title">
                      Convocatòria dels VI Premis Innovació i Salut
                    </div>
                    <div className="description">
                      <p>
                        La intel·ligència artificial també va ser la
                        protagonista en l'acte de convocatòria de la sisena
                        edició dels Premis Innovació i Salut, que es van
                        celebrar virtualment al novembre. L'acte va comptar amb
                        una ponència d'Alfonso Valencia sobre la medicina del
                        futur en temps de COVID-19.
                      </p>
                      <p>
                        Les mesures de distanciament social van obligar a
                        suspendre l’acte d’entrega de premis als guanyadors de
                        la cinquena edició, previst inicialment per al març del
                        2021.
                      </p>
                    </div>
                    <div className="btnVer">
                      <a
                        rel="noreferrer"
                        href="https://premios.mutuauniversal.net/es/"
                        target="_blank"
                      >
                        <BtnVer name="Llegir més"></BtnVer>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalActuacionContent>
        </div>
        <div className="changeBtn">
          <ChangeModalBtn />
        </div>
      </div>
    </Modal>
  )
}

export default Anticipamos
